import React, { FC, ReactNode } from "react";
import { Outlet } from "react-router";
import BreadcrumbContainer from "./Breadcrumb/BreadcrumbContainer";
import Drawer from "./Drawer/Drawer";
import NewNavigation from "./Header/NewNavigation";
import MobileDrawer from "./MobileDrawer/MobileDrawer";
import Overlay from "./MobileDrawer/Overlay";
import HelpDrawer from "./HelpDrawer/HelpDrawer";

import "./BaseLayout.scss";

interface IBaseLayoutProps {
    children?: ReactNode;
}

const BaseLayout: FC<IBaseLayoutProps> = ({ children }) => {
    return (
        <div>
            <NewNavigation />
            <div className="layout-container">
                <div className="desktop-layout-drawer">
                    <Drawer />
                </div>
                <div className="mobile-layout-drawer">
                    <MobileDrawer />
                    <Overlay />
                </div>
                <div className="layout-main">
                    <div style={{ height: "64px" }}></div>
                    <BreadcrumbContainer />
                    <Outlet />
                    {children}
                    {/*<div className="layout-footer">*/}
                    {/*    <Footer />*/}
                    {/*</div>*/}
                </div>
                <div className="desktop-layout-help-drawer">
                    <HelpDrawer />
                </div>
            </div>
        </div>
    );
};

export default BaseLayout;
